import jQuery from 'jquery';

const $ = jQuery;
window.jQuery = jQuery;
window.bst = {};

export function initializeTop() {
    // #リンク
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
    });

    // nav menu
    var menuOpenFlg = false;
    $('#nav-btn a').click(function () {
        var $nav = $(this).closest('.l-header__spmenu');
        if (!menuOpenFlg) {
            menuOpenFlg = true;
            $nav.addClass('is-open');
        } else {
            menuOpenFlg = false;
            // $('html, body').removeClass('u-body-mask');
            $nav.removeClass('is-open');
        }
    });

    $('.l-header__spmenu').click(function (event) {
        event.stopPropagation();
        if ($(event.target).is('.l-header__spmenu')) {
            if (menuOpenFlg) {
                $('.l-header__spmenu').removeClass('is-open');
                menuOpenFlg = false;
            }
        }
    });
}